module.exports = __webpack_public_path__ + "kangping/img/to-report.2731f54f.png";